import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./PagesLinks.scss";

export interface IPagesLinksProps{
    /**class */
    className?:string;
}

@pureRender
export class PagesLinks extends React.Component<IPagesLinksProps,any>{
    public render(){
        const {className} =this.props;
        const classNameSec=classnames(styles.sec,className);

        const urlParam=window.location.search;

        return (
            <div className={classNameSec}>
                <a href={window._CONFIG["PAGES"]["olduser"]+urlParam} className={styles.old} target="_blank" onClick={(e)=>(this.clickState("/OLD","/老用户"))}></a>
                <a href={window._CONFIG["PAGES"]["newuser"]+urlParam} className={styles.new} target="_blank" onClick={(e)=>(this.clickState("/NEW","/新用户"))}></a>
                
            </div>
        )
    }
    private showRule=()=>{
        new f2eGameUI.Dialog({
            classNames:{
                component:"rule-pop"
            }
        })
    }

    private clickState(eid,eid_desc){
        f2eGame.port.statpid.clickStat({eid:window.Global.statpidOption.eid+eid,eid_desc:window.Global.statpidOption.eid_desc+eid_desc})
    }
}

export default PagesLinks;



// WEBPACK FOOTER //
// ./src/components/PagesLinks/PagesLinks.tsx